import React, { useContext } from "react";

import ContentContext from "../../contexts/ContentContext";
import { CONTENT_TYPE } from "../content/Type";
import ContentAdminExternalForm from "../content/ContentAdminExternalForm";
import ContentLive from "../content/ContentLive";
import ContentHosted from "../content/ContentHosted";
import ContentFAST from "../content/ContentFAST";
import ContentMaster from "../content/ContentMaster";

function TabContentMedia() {
  const { item, isDisabled, onItemUpdate } = useContext(ContentContext);

  const { type } = item || {};
  const { FAST, HOSTED, MASTER, LIVE, EXTERNAL } = CONTENT_TYPE;
  const handleChange = (value, key) => {
    const updatedItem = { ...item };
    updatedItem[key] = value;
    onItemUpdate(updatedItem);
  };

  return (
    <>
      {type === FAST && (
        <ContentFAST content={item} onItemUpdate={onItemUpdate} />
      )}
      {type === HOSTED && (
        <ContentHosted item={item} onItemUpdate={onItemUpdate} />
      )}
      {type === MASTER && <ContentMaster />}
      {type === LIVE && <ContentLive />}

      {type === EXTERNAL && (
        <ContentAdminExternalForm
          item={item}
          disabled={isDisabled}
          onChange={handleChange}
        />
      )}
    </>
  );
}

export default TabContentMedia;
